import { createContext, useContext } from 'react'
import type { PathHelpers } from '@/hooks/usePathHelper'

// Keep context identity outside the refreshable path-helper module so Vite HMR cannot
// temporarily pair a previous provider with newly refreshed consumers.
const PathHelperContext = createContext<PathHelpers | null>(null)

function usePathHelper(): PathHelpers {
  const context = useContext(PathHelperContext)

  if (!context) {
    throw new Error('usePathHelper must be used within a PathHelperProvider')
  }

  return context
}

export { PathHelperContext, usePathHelper }
